import React from 'react';
import { useHistory } from 'react-router-dom';

import {FaCheck} from 'react-icons/fa'
// import logo from "../../../assets/logo-white.png";

import { Container, Content, Button, ConfirmIco, Title, Text, Information } from './styles';

const ConfirmationForgotPassword = () => {
  const history = useHistory();
  return (
    <Container>
      <div> 
      {/* <img src={logo} alt="logo"/>      */}
      <div />      

      <Content>
       
        <Information>
          <ConfirmIco>
            <FaCheck size={60} color="green" />
          </ConfirmIco>
          <Title>
            {' '}
            Sua solicitação foi <br /> realizada com sucesso!
          </Title>

          <Text>
            <span>Um link foi enviado para o email cadastrado.</span>
          </Text>

          <Text>
            <span>Após a alteração você terá acesso ao seu dashboard!</span>
          </Text>
          <Button onClick={() => {history.push('/')}}>
         Voltar para o login
        </Button>
        
        </Information>
        
      </Content>

       

      </div>
    </Container>
  );
};

export default ConfirmationForgotPassword;
